// config/highcharts-setup.ts
import Highcharts from 'highcharts'
import 'highcharts/highcharts-more' // enables arearange/columnrange
import 'highcharts/modules/dumbbell' // enables the dumbbell series
import 'highcharts/modules/accessibility' // enables accessibility features

export default Highcharts
